import { validationFactory } from '@hakla/typed-forms'
import { StringMap } from '@/shared/utils/map'

export const $each = validationFactory<[StringMap<any>]>('$each')
